import { FishType } from 'src/hooks/useFishs'
import { CountryType } from 'src/hooks/useCountries'
import { SizeType } from 'src/hooks/useSizes'

// Static, fish-themed mock data replacing the sunset stein.efishery.com API.
// Values mirror the live API's string/number types — the hooks parseInt/parseFloat them.

const sizeList: SizeType[] = [
    { size: 10 },
    { size: 20 },
    { size: 30 },
    { size: 40 },
    { size: 50 },
]

// Indonesian province -> city pairs used for fish records and the add-form select.
const areaList: CountryType[] = [
    { province: 'Jawa Barat', city: 'Bandung' },
    { province: 'Jawa Barat', city: 'Bekasi' },
    { province: 'DKI Jakarta', city: 'Jakarta Selatan' },
    { province: 'DKI Jakarta', city: 'Jakarta Timur' },
    { province: 'Jawa Tengah', city: 'Semarang' },
    { province: 'Jawa Tengah', city: 'Surakarta' },
    { province: 'Jawa Timur', city: 'Surabaya' },
    { province: 'Jawa Timur', city: 'Malang' },
    { province: 'Bali', city: 'Denpasar' },
    { province: 'Sulawesi Selatan', city: 'Makassar' },
    { province: 'Sumatera Utara', city: 'Medan' },
    { province: 'Yogyakarta', city: 'Yogyakarta' },
]

// [komoditas, areaIndex, size, price]
const seeds: [string, number, number, number][] = [
    ['Bandeng', 0, 30, 32000],
    ['Lele', 0, 20, 21000],
    ['Nila', 0, 30, 28000],
    ['Gurame', 1, 40, 55000],
    ['Patin', 1, 30, 26000],
    ['Mas', 1, 20, 30000],
    ['Kakap Merah', 2, 50, 95000],
    ['Tuna', 2, 50, 120000],
    ['Udang', 2, 10, 88000],
    ['Tongkol', 3, 40, 34000],
    ['Kembung', 3, 20, 30000],
    ['Cumi', 3, 20, 72000],
    ['Bandeng', 4, 30, 31000],
    ['Bawal', 4, 30, 45000],
    ['Kerapu', 4, 50, 110000],
    ['Lele', 5, 20, 20000],
    ['Nila', 5, 30, 27000],
    ['Gurame', 5, 40, 52000],
    ['Tuna', 6, 50, 125000],
    ['Kakap Merah', 6, 50, 98000],
    ['Udang', 6, 10, 90000],
    ['Patin', 7, 30, 25000],
    ['Mujair', 7, 20, 23000],
    ['Bawal', 7, 30, 47000],
    ['Tuna', 8, 50, 135000],
    ['Kerapu', 8, 50, 115000],
    ['Cumi', 8, 20, 78000],
    ['Kakap Merah', 9, 50, 102000],
    ['Tongkol', 9, 40, 36000],
    ['Kembung', 9, 20, 31000],
    ['Bandeng', 10, 30, 33000],
    ['Udang', 10, 10, 92000],
    ['Nila', 10, 30, 29000],
    ['Gurame', 11, 40, 54000],
    ['Lele', 11, 20, 22000],
    ['Mas', 11, 20, 31500],
]

const BASE_TS = 1735689600000 // 2025-01-01T00:00:00Z
const DAY = 86400000

const fishList: FishType[] = seeds.map(([komoditas, areaIdx, size, price], i) => {
    const area = areaList[areaIdx]
    const timestamp = BASE_TS + i * DAY // varied -> newest-first sort shows a spread
    return {
        uuid: `mock-${(i + 1).toString().padStart(4, '0')}`,
        komoditas,
        area_provinsi: area.province,
        area_kota: area.city,
        size,
        price,
        tgl_parsed: new Date(timestamp).toISOString(),
        timestamp,
    }
})

export { fishList, areaList, sizeList }
